import { randomNeighbour } from "../neighbour.js";
// export const visitorRandomContiguous = (
//   grid: Grid,
//   start: Cell,
//   opts: VisitorOpts = {}
// ) =>
//   visitor(
//     ,
//     grid,
//     start,
//     opts
//   );
export const randomContiguousLogic = () => {
    return {
        select: randomNeighbour,
    };
};
